<footer>
  <div class="content">
    <div class="left">
      <a
        routerLink=""
        routerLinkActive="active"
        title="Startseite"
        logo
        queryParamsHandling="merge"
      >
        <vee-logo></vee-logo>
      </a>
      <nav>
        <a
          routerLink="/impressum"
          routerLinkActive="active"
          queryParamsHandling="merge"
          >{{ "LEGAL_NOTICE.TITLE" | translate }}
        </a>
        <a
          routerLink="/datenschutz"
          routerLinkActive="active"
          queryParamsHandling="merge"
        >
          {{ "PRIVACY.TITLE" | translate }}
        </a>
      </nav>
    </div>
    <div class="right">
      @for (link of socialMediaLinks; track $index) {
        <a
          class="btn-flat white"
          [href]="link.href"
          [title]="link.title"
          rel="noopener"
          target="_blank"
        >
          <vee-icon [icon]="link.icon" weight="brands" size="xl"></vee-icon>
        </a>
      }
    </div>
  </div>
</footer>
